import * as v from 'valibot';

const feinRegExp = /^\d{2}-?\d{7}$/;

export const currentEmployerApproval = v.pipe(
  v.object({
    employmentStartDate: v.pipe(v.string('Required'), v.nonEmpty('Required')),
    employmentEndDate: v.optional(v.string()),
    currentEmployee: v.boolean('Required'),
    weeklyHours: v.pipe(v.number('Required'), v.minValue(0, 'Must be a positive number')),
    employmentStatus: v.pipe(v.string('Required'), v.nonEmpty('Required')),
    employerInfoCorrect: v.boolean('Required'),
  }),
  // Conditional validation: employmentEndDate required when NOT current employee
  v.forward(
    v.check((input) => {
      // If not current employee, employmentEndDate must be present
      if (!input.currentEmployee && !input.employmentEndDate) {
        return false;
      }
      return true;
    }, 'Required'),
    ['employmentEndDate']
  )
);

/**
 * Factory function that creates a non-partner employer approval schema
 * @param currentEmployee Whether the person is currently employed
 */
export const currentNonPartnerEmployerApproval = (currentEmployee: boolean) =>
  v.object({
    employerApartment: v.optional(v.nullish(v.string())),
    employerCity: v.pipe(
      v.nullish(v.string(), () => ''),
      v.nonEmpty('City is required')
    ),
    employerEin: v.pipe(
      v.nullish(v.string(), () => ''),
      v.nonEmpty('Required'),
      v.regex(feinRegExp, 'EIN must be 9 digits')
    ),
    employerName: v.pipe(
      v.nullish(v.string(), () => ''),
      v.nonEmpty('Company name is required')
    ),
    employerState: v.pipe(
      v.nullish(v.string(), () => ''),
      v.nonEmpty('Company state is required')
    ),
    employerStreetAddress: v.pipe(
      v.nullish(v.string(), () => ''),
      v.nonEmpty('Street address is required')
    ),
    employerWebsite: v.optional(v.nullish(v.string())),
    employerZip: v.pipe(
      v.nullish(v.string(), () => ''),
      v.nonEmpty('Postal code is required')
    ),
    employmentEndDate: currentEmployee
      ? v.optional(v.nullish(v.string()))
      : v.pipe(
          v.nullish(v.string(), () => ''),
          v.nonEmpty('End date is required if employee is not current')
        ),
    employmentHours: v.pipe(
      v.nullish(v.number(), () => 0),
      v.minValue(0, 'Must be a positive number')
    ),
    employmentStartDate: v.pipe(
      v.nullish(v.string(), () => ''),
      v.nonEmpty('Required')
    ),
    employmentStatus: v.pipe(
      v.nullish(v.string(), () => ''),
      v.nonEmpty('Required')
    ),
  });

export default null; // silence a false warning
